import Service from './service'
export default [
  {
    path: '/service',
    name: 'home-service',
    component: Service
  }
]



// WEBPACK FOOTER //
// ./src/components/service/service-router.js